"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extension_onServerError = exports.extension_onNoChannel = exports.extension_onPasswordWrong = exports.extension_onHostLeft = exports.extension_onVersionFail = exports.extension_process = exports.extension_sendWorldState = exports.extension_onUpdate = exports.extension_onOtherLeave = exports.extension_onOtherJoin = exports.extension_onMeJoin = exports.extension_getRemoteServerAddress = exports.extension_getLocalServerAddress = void 0;
var websockets_1 = require("@engine/websockets");
var common_sidecar_1 = require("@main/common-sidecar");
// import { diveMultiplayerCursors } from '@dive/indicators/diveMultiplayerCursors-sidecar'
var diveMessages_sidecar_1 = require("@dive/misc/diveMessages-sidecar");
// import { diveMultiUtilities_syncWorld } from '@dive/multi/diveMultiUtilities_syncWorld-sidecar'
var crokinoleMultiplayerCursors_sidecar_1 = require("@crokinole/cursors/crokinoleMultiplayerCursors-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var crokinole_cursor_sidecar_1 = require("./crokinole_cursor-sidecar");
var voyageMessages_sidecar_1 = require("@voyage/multi/voyageMessages-sidecar");
var crokinoleCamera_sidecar_1 = require("@crokinole/main/crokinoleCamera-sidecar");
var crokinoleSimulationManager_sidecar_1 = require("@crokinole/main/crokinoleSimulationManager-sidecar");
// import { voyageUiMessage } from '@voyage/ui/voyageUiMessage-sidecar'
// import { voyageMessageCursor } from './voyageMessageCursor-sidecar'
// import { voyageMessages } from './voyageMessages-sidecar'
var namespace = 'crokinoleWebsockets_extensions';
//TODO: move these to extension file and add bulk of this file to engine
function extension_getLocalServerAddress() {
    if (window.location.hostname === 'localhost') {
        return 'ws://localhost:8901'; // TODO: new chess server
    }
    else {
        // Ack, any way to get this from the browser?
        return 'ws://192.168.68.64:8901'; // TODO: new chess server
    }
}
exports.extension_getLocalServerAddress = extension_getLocalServerAddress;
function extension_getRemoteServerAddress() {
    // return 'wss://ws-voyage.keepflyinggames.com' // TODO: new chess server
    return 'wss://ws-keepflyingtogether.keepflyinggames.com';
}
exports.extension_getRemoteServerAddress = extension_getRemoteServerAddress;
function extension_onMeJoin() {
    // chessGameManager.goGame()
    console.log(namespace, 'extension_onMeJoin', '???');
    // voyageGameManager.goGame()
    if (websockets_1.getIsHost()) {
        console.log('!! Connected to server as host', 'Load world');
        diveMessages_sidecar_1.diveMessages.setMessage('Connected to server as (host)');
        websockets_sidecar_1.websockets.setMultiName('pHost');
        // voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
        //   // command: EHostCommand.LoadScenario,
        //   command: EHostCommand.old_NewScenario,
        // })
    }
    else {
        console.log('!! Connected to server as client', 'Sync world');
        diveMessages_sidecar_1.diveMessages.setMessage('Connected to server as (client)');
        websockets_sidecar_1.websockets.setMultiName('pClient'); // TODO: multiple clients
        // voyageGameManager.goScenario_sync()
    }
    crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.setIsRunning(false);
    // TODO: reset world
    crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.setIsRunning(true);
    crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().simulationMode = 'game';
}
exports.extension_onMeJoin = extension_onMeJoin;
function extension_onOtherJoin(multiId, name) {
    console.log(namespace, 'extension_onOtherJoin', multiId);
    diveMessages_sidecar_1.diveMessages.setMessage('NET Player joined');
    // TODO: add cursors in!
    var cur = crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.findByMultiIdSafe(multiId);
    crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.setName(cur, name);
    if (websockets_1.getIsHost()) {
        console.log('!! detecting new player', 'Sync world');
        // Resync game
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.setIsRunning(false);
        // TODO: reset world
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.setIsRunning(true);
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().simulationMode = 'game';
        // diveSimulationManager.setIsRunning(false)
        // TODO: handle this better elsewhere? Doesn't seem to always work
        //diveMultiUtilities_syncWorld.diveMulti_syncWorld()
        // diveSimulationManager.setIsRunning(true)
    }
    // if (getIsHost()) {
    //   console.log('!! I am host RESET WORLD')
    //   voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
    //     command: EHostCommand.Reset,
    //   })
    // }
}
exports.extension_onOtherJoin = extension_onOtherJoin;
function extension_onOtherLeave(multiId) {
    console.log(namespace, 'extension_onOtherLeave', multiId);
    diveMessages_sidecar_1.diveMessages.setMessage('NET Player left');
    // TODO: add cursors in!
    var cur = crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.findByMultiIdSafe(multiId);
    if (cur) {
        crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.kill(cur);
    }
}
exports.extension_onOtherLeave = extension_onOtherLeave;
var _updateTimer = 0;
var _updateTime = crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.mouseCursorUpdateTime;
var _lastMou = { x: 0, y: 0 };
function extension_onUpdate() {
    var dt = common_sidecar_1.common.getUpdateDelta();
    _updateTimer += dt;
    if (_updateTimer > _updateTime) {
        _updateTimer = 0;
        var mou = crokinoleCamera_sidecar_1.crokinoleCamera.getCursorWorldPosition();
        if (mou.x !== _lastMou.x || mou.y !== _lastMou.y) {
            // console.log(
            //   namespace,
            //   'update cursor',
            //   mou.x,
            //   _lastMou.x,
            //   mou.y,
            //   _lastMou.y,
            // )
            crokinole_cursor_sidecar_1.crokinole_cursor.sendMessageToOthers({
                x: mou.x,
                y: mou.y,
            });
        }
        _lastMou = mou;
    }
}
exports.extension_onUpdate = extension_onUpdate;
function extension_sendWorldState(multiId) {
    if (websockets_1.getIsHost()) {
        // TODO: should we use this implementation instead?
        console.log(namespace, 'extension_sendWorldState', 'ignored');
        // voyageMessageHostCommand.sendMessageWorldState(
        //   {
        //     command: EHostCommand.Clear,
        //   },
        //   multiId,
        // )
        // // Load ship
        // let status = voyageGameStatus.get()
        // voyageMessageLoadShip.sendMessageWorldState(
        //   {
        //     filename: status.shipFilename,
        //   },
        //   multiId,
        // )
    }
}
exports.extension_sendWorldState = extension_sendWorldState;
function extension_process(m, skipFrom) {
    // TODO: process messages!
    // voyageMessages.process(m, skipFrom)
    // .. crokinolemessage
    // TODO: replace with crokinolemessages
    voyageMessages_sidecar_1.voyageMessages.process(m, skipFrom);
}
exports.extension_process = extension_process;
function extension_onVersionFail(serverVersion, yourVersion) {
    diveMessages_sidecar_1.diveMessages.setMessage('NET Version fail');
    // TODO: add version fail
    // voyageUiMessage.setText(
    //   'A new version is available!',
    //   'Please download the latest version ' +
    //     serverVersion +
    //     ' to continue. ' +
    //     '\n\nYour version: ' +
    //     yourVersion,
    // )
    // voyageUiMessage.setOpen(true, () => {
    //   window.open(
    //     'https://www.keepflyinggames.com/games/keep-flying-together/latest-version',
    //   )
    // })
}
exports.extension_onVersionFail = extension_onVersionFail;
function extension_onHostLeft() {
    diveMessages_sidecar_1.diveMessages.setMessage('NET Host left');
    // chessGameManager.goMenuMain()
    // chessUiMessage.setText('Game closed', 'Host has closed the game room')
    // chessUiMessage.setOpen(true)
}
exports.extension_onHostLeft = extension_onHostLeft;
function extension_onPasswordWrong() {
    diveMessages_sidecar_1.diveMessages.setMessage('NET Wrong password');
    // TODO: implement server error
    // chessGameManager.goMenuMain()
    // chessUiMessage.setText(
    //   'Wrong password',
    //   'Please check the password and try again',
    // )
    // chessUiMessage.setOpen(true)
}
exports.extension_onPasswordWrong = extension_onPasswordWrong;
function extension_onNoChannel() {
    diveMessages_sidecar_1.diveMessages.setMessage('NET No channel');
    console.log('!! No channel');
    // Auto-reconnect
    setTimeout(function () {
        console.log('!! Retrying join channel');
        websockets_1.joinChannel('test', false, true, '');
    }, 500);
    // TODO: implement server error
    // chessGameManager.goMenuMain()
    // chessUiMessage.setText(
    //   'Wrong password',
    //   'Please check the password and try again',
    // )
    // chessUiMessage.setOpen(true)
}
exports.extension_onNoChannel = extension_onNoChannel;
function extension_onServerError() {
    diveMessages_sidecar_1.diveMessages.setMessage('NET Server error');
    // TODO: implement server error
    // chessGameManager.goMenuMain()
    // chessUiMessage.setText(
    //   'Server error',
    //   'The server has encountered an error, please try again later',
    // )
    // chessUiMessage.setOpen(true)
}
exports.extension_onServerError = extension_onServerError;
